function toggleFilters() {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    sidebar.classList.toggle('active');
    document.body.classList.toggle('VarCol-no-scroll'); // Disable background scroll
}

document.addEventListener('click', function(event) {
    const sidebar = document.querySelector('.VarCol-custom-sidebar-filters');
    if (sidebar.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
    } else {
        document.body.style.overflow = 'auto';
    }
});

function updateDuctlessCounts() {
    const items = document.querySelectorAll('.VarCol-variant-collection-item');
    let yesCount = 0;
    let noCount = 0;

    items.forEach(item => {
        const isDuctless = item.getAttribute('data-ductless');
        if (isDuctless === "Yes") {
            yesCount++;
        } else if (isDuctless === "No") {
            noCount++;
        }
    });

    document.getElementById('ductless-yes-count').textContent = `(${yesCount})`;
    document.getElementById('ductless-no-count').textContent = `(${noCount})`;
}

function VarColApplyFilters() {
    // Get selected CFM ranges
    const selectedCFMs = Array.from(document.querySelectorAll('.VarCol-filter-cfm:checked')).map(input => input.value);

    // Check if Ductless, Outdoors, and Fast Shipping checkboxes are selected
    const ductlessSelected = document.querySelector('.VarCol-filter-ductless:checked') !== null;
    const outdoorsSelected = document.querySelector('.VarCol-filter-outdoors:checked') !== null;
    const fastShippingSelected = document.querySelector('.VarCol-filter-fast-shipping:checked') !== null;

    // Get all variant items
    const items = document.querySelectorAll('.VarCol-variant-collection-item');

    items.forEach(item => {
        const itemCFM = parseInt(item.getAttribute('data-cfm'), 10); // Parse CFM value as a number
        const itemDuctless = item.getAttribute('data-ductless'); // Ductless value of the Product
        const itemFinish = item.getAttribute('data-outdoors'); // Finish value of the Product
        const itemInventory = item.getAttribute('data-sale'); // Custom Badge pull

        // Determine if the item matches the selected CFM range
        const showByCFM = selectedCFMs.length === 0 || selectedCFMs.some(range => {
            if (range === "600-900") {
                return itemCFM >= 600 && itemCFM <= 900;
            }
            if (range === "900-1200") {
                return itemCFM > 900 && itemCFM <= 1200;
            }
            if (range === "1200+") {
                return itemCFM > 1200;
            }
            if (range === "Variable") {
                return itemCFM === null || isNaN(itemCFM);
            }
            return false;
        });

        // Determine visibility based on other filters
        const showByDuctless = !ductlessSelected || (itemDuctless === "Ductless convertible with accessory");
        const showByOutdoors = !outdoorsSelected || (itemFinish === "true");
        const showByFastShipping = !fastShippingSelected || (itemInventory === "SALE");

        // Apply final visibility logic
        item.style.display = (showByCFM && showByDuctless && showByOutdoors && showByFastShipping) ? 'block' : 'none';
    });
}




// Call this function whenever filters are changed
document.querySelectorAll('.VarCol-filter-cfm, .VarCol-filter-ductless, .VarCol-filter-outdoors').forEach(input => {
    input.addEventListener('change', VarColApplyFilters);
});
// Ensure checkbox is toggled when the label or surrounding area is clicked
document.querySelectorAll('.VarCol-filter-label').forEach(label => {
    label.addEventListener('click', (e) => {
        const checkbox = label.querySelector('input[type="checkbox"]');
        if (checkbox) {
            // Toggle the checkbox state explicitly
            if (checkbox.checked) {
                checkbox.checked = false;
            } else {
                checkbox.checked = true;
            }

            // Trigger the change event to ensure filters are applied
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Prevent default label behavior (if any)
        e.preventDefault();
    });
});

// Initial call to apply filters on page load
document.addEventListener('DOMContentLoaded', VarColApplyFilters);


document.querySelectorAll('.VarCol-accordion-button').forEach(button => {
    button.addEventListener('click', () => {
        button.classList.toggle('open');
        const content = button.nextElementSibling;
        content.style.display = content.style.display === 'block' ? 'none' : 'block';
    });
});

function VarColApplySort() {
    console.log("VarColApplySort function triggered");  // Check if the function is triggered

    const sortBy = document.getElementById('VarCol-sort-by').value;
    const grid = document.getElementById('VarCol-collection-product-grid');

    // Ensure grid is found
    if (!grid) {
        console.error('Grid not found');
        return;
    }

    const items = Array.from(grid.getElementsByClassName('VarCol-variant-collection-item'));

    console.log(items);  // Log items to check if they are properly retrieved

    items.sort((a, b) => {
        const priceElementA = a.querySelector('.card-price');
        const priceElementB = b.querySelector('.card-price');

        // Ensure the price elements exist
        if (!priceElementA || !priceElementB) {
            console.error('Price element not found');
            return 0;  // If no price element, keep the order unchanged
        }

        const priceA = parseFloat(priceElementA.dataset.minPrice);
        const priceB = parseFloat(priceElementB.dataset.minPrice);

        if (sortBy === 'price-low-to-high') {
            return priceA - priceB;
        } else if (sortBy === 'price-high-to-low') {
            return priceB - priceA;
        }
        return 0;  // Default to no change if no sorting selected
    });

    grid.innerHTML = '';  // Clear the grid
    items.forEach(item => grid.appendChild(item));  // Append sorted items back
}
